
<template>
    <b-card class="guest-invoices-setup-base-card mt-2" no-body>
        <b-card-body>
            <slot name="card-body"></slot>
        </b-card-body>
    </b-card>
</template>

<script>
export default { name: 'GuestInvoicesSetupBaseCard' };
</script>

<style lang="scss" scoped>
@import '../../../../../scss/bootstrap-extended/bootstrap-extended.scss';

:deep(.ag-root-wrapper) {
    overflow: visible;
}

:deep(.card-body) {
    padding: 1rem !important;
}

:deep(.row) {
    padding: 0.3rem !important;
}

:deep(.col) {
    align-self: center !important;
}

:deep(.form-group) {
    margin-bottom: 0px !important;
}

.guest-invoices-setup-base-card {
    border: none !important;
    height: 100%;

    @include media-breakpoint-up(md) {
        margin-right: 0.5rem;
    }

    &__clickable-cell {
        text-decoration: underline;
        word-break: break-word;
    }
}
</style>
